import PhotoUploadOnboarding from './PhotoUploadOnboarding';

export default PhotoUploadOnboarding;
